import React from 'react';
export var GenericSquare = function (_a) {
    var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, width = _a.width, height = _a.height, stroke = _a.stroke, fill = _a.fill, children = _a.children, _d = _a.notBounding, notBounding = _d === void 0 ? false : _d, className = _a.className;
    return (React.createElement("svg", { x: x, y: y, width: width, height: height },
        React.createElement("rect", { className: className, "data-not-bounding": notBounding, width: width, height: height, style: {
                stroke: stroke,
                fill: fill,
                strokeWidth: 1,
            } }),
        children));
};
//# sourceMappingURL=generic-square.js.map